module.exports = __webpack_public_path__ + "static/media/Furutech Demag.b84416d6.jpg";